// extracted by mini-css-extract-plugin
export default {"buttons":"sX2SAykviglOcZauQCUt","bankCard":"bF8wV4ub6hgAmRhKNqtK","placeHolderShimmer":"i_CHo2mRVE0ixfAx5AKO"};